import React from 'react';

const DashboardContext = React.createContext({
  isOABFormPublished: false
});
const { Provider, Consumer } = DashboardContext;

const DashboardContextProvider = (props) => {
  const [isOABFormPublished, setOABFormIsPublished] = React.useState<boolean>(false)

  const changeIsPublish = (value) => {
    setOABFormIsPublished(value)
  }

  return (
    <Provider
      value={{ isOABFormPublished, changeIsPublish } as any}
    >
      {props.children}
    </Provider>
  );
};

export { DashboardContext, DashboardContextProvider, Consumer as DashboardContextConsumer };
